import { useCallback, useEffect, useRef } from 'react';
import { debounce } from 'lodash';

const useDebouncedCallback = (callback, delay, options) => {
    const callbackRef = useRef(callback);
    const debouncedCallback = useRef();

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        debouncedCallback.current = debounce(
            (...args) => callbackRef.current(...args),
            delay,
            options
        );

        return () => {
            debouncedCallback.current.cancel();
        };
    }, [delay, options]);

    return useCallback((...args) => {
        debouncedCallback.current(...args);
    }, []);
};

export default useDebouncedCallback;
